<template>
  <div class="drawer-layout__left-toolbar">
    <el-button icon="el-icon-back" round class="drawer-layout__back-btn" @click="$emit('back')">
      返回
    </el-button>

    <div class="order-settings-popover">
      <el-popover v-model="popoverVisible" placement="bottom-end" trigger="click" width="160" popper-class="settings-menu-popper">
        <div class="order-settings-menu">
          <el-button round size="small" class="order-settings-menu__btn" @click.stop="onSettingsClick('history')">操作紀錄</el-button>
          <el-button v-if="showRescheduleOrderBtn" round size="small" class="order-settings-menu__btn" @click.stop="onSettingsClick('reschedule')">修改日期</el-button>
          <el-button v-if="showRefundBtn" round size="small" class="order-settings-menu__btn" @click.stop="onSettingsClick('refund')">處理退款</el-button>
          <el-button
            v-if="showSettingsCancelOrderBtn"
            round
            size="small"
            class="order-settings-menu__btn cancel-order-btn"
            @click.stop="onSettingsClick('cancel')"
            >取消訂單</el-button
          >
        </div>

        <el-button slot="reference" type="text" icon="el-icon-setting" class="order-settings-trigger" @click.stop />
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewOrderLeftToolbarPartial',
  props: {
    showRescheduleOrderBtn: { type: Boolean, default: false },
    showRefundBtn: { type: Boolean, default: false },
    showSettingsCancelOrderBtn: { type: Boolean, default: false },
  },
  data() {
    return {
      popoverVisible: false,
    }
  },
  methods: {
    onSettingsClick(action) {
      this.popoverVisible = false
      this.$emit('settings-action', action)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/hotel-view-order.scss';
</style>
